<template>
  <div class="tabs_content" id="tab-2">
      <popup v-show="hasPopup"
             :popup-type="getPopupType"
             :popup-action="getPopupAction"
             @popup-action="executePopupAction"
      />

      <section>
          <a :data-title="$gettext('Přenačíst MAC adresy')" class="tab_button tab_button_refresh title_tooltip" @click.stop="_reloadDeviceEntity" />

          <div class="status">
              <h2 v-translate>MAC Adresy zařízení</h2>
              <a
                  v-if="isEditable"
                                    :title="'Přidat MAC adresu' | translate"
                  :class="['add', 'add_expand', { open: newMacAddressOpen }]"
                  @click.prevent="toggleNewMacAddress()"
                  v-translate>Přidat MAC adresu
              </a>
          </div>
          <div :class="['filter', 'expand_content', { open: newMacAddressOpen }]">
              <div class="field_left">
                  <text-input
                      id="mac-address-add"
                      v-model="newMacAddress.mac_address"
                      :required="true"
                      ref="newmacaddressref"
                  >
                      <translate class="translate">MAC adresa</translate>
                  </text-input>
              </div>
            <div class="field_right field_btn">
              <p class="field">
                <input
                    type="submit"
                    class="btn"
                    :value="'Uložit' | translate"
                    @click.prevent.stop="onAddNewMacAddress"
                />
              </p>
            </div>
          </div>
          <div class="table_overflow">
            <table class="vypis">
              <not-sorting-table-header
                  v-if="entity.mac_addresses.length > 0"
                  :titles="macAddressTableTitles"
                  :useRight="false"
                  :dragDrop="true"
                  :checkbox="true"
              />
              <tbody>
                  <mac-address-row
                      v-for="macAddress in entity.mac_addresses"
                      :macAddress="macAddress"
                      :isEditable="isEditable"
                      :key="macAddress.id"
                      @delete-mac-address="onDeleteMacAddress"
                      :selectedEntities="selectedEntities"
                      @input="select"
                  />
                  <tr v-if="entity.mac_addresses.length === 0">
                    <td :colspan="macAddressTableTitles.length" v-translate>Zařízení nemá přiřazené žádné MAC adresy.</td>
                  </tr>
              </tbody>
          </table>
          </div>
        <local-list-action-line
            :entities="entity.mac_addresses"
            :selected-entities="selectedEntities"
            :multiple-action-options="multipleActionOptions"
            @select-all="toggleSelectAll"
            @run-multiple-action="runMultipleAction"
        ></local-list-action-line>
      </section>
  </div>
</template>

<script>
import MacAddressRow from "./MacAddressRow";
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import popup from "@/components/mixins/popup"
import message from "@/components/mixins/message"
import Popup from "@/components/common/Popup"
import localTable from "@/components/mixins/local-table"

export default {
    name: "DeviceMacAddresses",
    components: {MacAddressRow, NotSortingTableHeader, Popup},
    mixins: [popup, message, localTable],
    props: {
        entity: Object,
        isEditable: Boolean,
    },
    created(DeviceService) {
        this.deviceService = DeviceService
    },
    data() {
        return {
            newMacAddressOpen: false,
            newMacAddress: {
                mac_address: null
            }
        }
    },
    methods: {
        _reloadDeviceEntity() {
            this.$emit('reloadEntity');
        },
        toggleNewMacAddress() {
            this.newMacAddressOpen = !this.newMacAddressOpen;
        },
        onDeleteMacAddress(macAddress, showPopup = true) {
            if (showPopup) {
                this.showPopup(macAddress, 'delete', 'delete-mac-address')
            } else {
                this.deviceService.deleteMacAddress(macAddress)
                    .then(() => {
                        this.setSuccessMessage()
                        this.$emit('reloadEntity');
                    }).catch(function (error) {
                        this.setErrorMessage(this._processDetailErrorMessage(error))
                    }.bind(this))
            }
        },
        onAddNewMacAddress() {
            if (this.newMacAddress.mac_address) {
                this.$refs.newmacaddressref.setForcedInvalid(false);

                this.deviceService.createMacAddress(this.entity.id, this.newMacAddress)
                    .then(() => {
                        this.setSuccessMessage()
                        this._reloadDeviceEntity();
                        this.newMacAddress = {mac_address: null};
                        this.newMacAddressOpen = false;
                    }).catch((error) => {
                        this.setErrorMessage(this._processDetailErrorMessage(error));
                    });
            } else {
                this.$refs.newmacaddressref.setForcedInvalid(true, this.$gettext('Pole musí být vyplněno.'));
            }
        },
        executePopupAction(value) {
            if (value) {
                if (this.getPopupAction === 'delete-mac-address') {
                    this.onDeleteMacAddress(this.getPopupId, false)
                }
            }
            this.hidePopup()
        }
    },
    computed: {
        entities(){
          return Object.values(this.entity.mac_addresses);
        },
        csvHeaders(){
          return {
            'mac_address': {name: this.$gettext('MAC Adresa')},
            'timestamp_first_usage': {name: this.$gettext('První použití'), callback: (entity) => {return entity.timestamp_first_usage ? this.$_datetime_format(entity.timestamp_first_usage) : ''}},
            'timestamp_last_usage': {name: this.$gettext('Poslední použití'), callback: (entity) => {return entity.timestamp_last_usage ? this.$_datetime_format(entity.timestamp_last_usage) : ''}},
            'timestamp_created': {name: this.$gettext('Vytvořeno')},
            'timestamp_updated': {name: this.$gettext('Upraveno')},
          }
        },
        macAddressTableTitles() {
            return [
                this.$gettext('MAC Adresa'),
                this.$gettext('První použití'),
                this.$gettext('Poslední použití'),
                this.$gettext('Vytvořeno'),
                this.$gettext('Upraveno')
            ]
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/MacAddresses.vue